import { gql } from '@apollo/client';

export const GET_PRICE_VS_MARKET_DIFFERENCE_PERCENTAGE_HISTORY = gql`
  query GetPriceVsMarketDifferencePercentageHistory($vendorNames: [String!]!) {
    getPriceVsMarketDifferencePercentageHistory(vendorNames: $vendorNames) {
      dateISO8601
      vendorPriceVsMarketPercentage
    }
  }
`;
